import {Component, ViewChild} from '@angular/core';
import {IonicPage, NavController, NavParams, PopoverController, Refresher} from 'ionic-angular';
import {LoyaltyInfoPopoverPage} from "../loyalty-info-popover/loyalty-info-popover";
import {LoyaltyServiceProvider} from "../../providers/loyalty-service/loyalty-service";
import moment from "moment";

@IonicPage()
@Component({
  selector: 'page-loyalty-rewards-barbershop',
  templateUrl: 'loyalty-rewards-barbershop.html',
})
export class LoyaltyRewardsBarbershopPage {

  public loading: boolean;
  public loyalty: any;
  public userId: any;
  public shop: any;
  public loadingMore: boolean = false;

  public currentPage: number;
  public nextPage: number;
  public lastPage: number;

  @ViewChild(Refresher) refresher: Refresher;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public loyaltyProvider: LoyaltyServiceProvider,
  ) {
    this.userId = localStorage.getItem('tuid');
    this.shop = navParams.get('shop');
  }

  ionViewDidEnter() {
    this.loading = true;
    this.getShopLoyaltyPoints().then(() => {
      this.loading = false;
    })
  }

  getShopLoyaltyPoints() {
    return this.loyaltyProvider.getShopLoyaltyPoints(this.userId, this.shop.id).then((loyalty: any) => {
      this.loyalty = loyalty;
      this.setPagination(this.loyalty.points);
    })
  }

  pluralisePointsString(number){
    if (number <= 1){
      return 'point';
    } else {
      return 'points';
    }
  }

  spentOrEarned(loyaltyPoint) {
    if (loyaltyPoint.redeemed_at) return `You spent ${loyaltyPoint.total_points} ${this.pluralisePointsString(loyaltyPoint.total_points)}` ;

    return `You earned ${loyaltyPoint.total_points} ${this.pluralisePointsString(loyaltyPoint.total_points)}`;
  }

  pointsClass(loyaltyPoint) {
    if (loyaltyPoint.redeemed_at) return 'bg-brand-blue';

    return 'bg-teal'
  }

  displayPoints(loyaltyPoint) {
    if (loyaltyPoint.redeemed_at) return '-' + loyaltyPoint.total_points;

    return '+' + loyaltyPoint.total_points;
  }

  pointsDate(loyaltyPoint) {
    if (loyaltyPoint.redeemed_at) return moment(loyaltyPoint.redeemed_at).format('Do MMM YYYY');

    return moment(loyaltyPoint.updated_at).format('Do MMM YYYY');
  }

  infoPopover() {
    let checkinPopover = this.popoverCtrl.create(LoyaltyInfoPopoverPage,
      {},
      {
        cssClass: 'complete-booking-modal',
        enableBackdropDismiss: false
      });

    checkinPopover.present();

    checkinPopover.onDidDismiss(() => {

    })
  }

  setPagination(loyaltyPoints) {
    this.lastPage = loyaltyPoints.last_page;
    this.currentPage = loyaltyPoints.current_page;
    this.nextPage = (this.currentPage < this.lastPage ? this.currentPage + 1 : null);
  }

  getLoyaltyPointsFromPage(page: number) {
    return new Promise((resolve, reject) => {
      this.loyaltyProvider.getShopLoyaltyPointsHistory(this.userId, this.shop.id, page).then((loyaltyPoints: any) => {
        this.setPagination(loyaltyPoints);
        return resolve(loyaltyPoints.data);
      }).catch((error) => {
        return reject(error);
      });
    });
  }

  loadMore() {
    this.loadingMore = true;
    this.getLoyaltyPointsFromPage(this.nextPage).then((loyaltyPoints: any) => {
      this.loyalty.points.data = this.loyalty.points.data.concat(loyaltyPoints);
      this.loadingMore = false;
    }).catch((error) => {
      this.loadingMore = false;
    });
  }

  pullToRefresh(event) {
    this.getShopLoyaltyPoints().then(() => {
      this.refresher.complete()
    }).catch(() => {
      this.refresher.complete()
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/loyalty-rewards-barbershop/loyalty-rewards-barbershop.ts